<template>
  <g
    class="map-contact-pin"
    :class="{ 'is-selected': selected }"
    :transform="transform"
    @click.stop="onClick"
  >
    <circle :cx="props.contact.location.x" :cy="props.contact.location.y" :r="pinRadius" />
  </g>
</template>

<script setup>
  import { computed, inject } from "vue";

  const props = defineProps({
    contact: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      required: false,
      default: false
    },
    transform: {
      type: String,
      required: false,
      default: "scale(1, -1)"
    }
  });

  const emit = defineEmits(["click"]);
  const zooms = inject("mapZooms");
  const zoom = inject("mapZoom");

  const pinRadius = computed(() => {
    const maxZoom = Math.max(...zooms.value.map(z => z.zoom)) + 1;
    return 5 * (maxZoom - zoom.value);
  });

  function onClick() {
    emit("click", props.contact);
  }
</script>

<style scoped>
  .map-contact-pin {
    cursor: pointer;
    color: #1976d2;
  }

  .map-contact-pin.is-selected {
    color: #d32f2f;
  }

  .map-contact-pin circle {
    fill: currentColor;
    fill-opacity: 0.35;
    stroke: currentColor;
    stroke-width: 1.5;
  }
</style>